var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":"","text-center":""}},[_c('h1',[_vm._v("This page does not exist.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }